<span class="navbar-icon {{ set }} {{ set }}-{{ icon }}"></span>
